<template>

  <div v-if="anterior > 0">
    <span class="text-muted"> {{Math.abs(  anterior - atual)  }}</span>
    <i class="fa fa-arrow-up" style="color:green" v-if="atual < anterior"></i>
    <i class="fa fa-arrow-down" style="color:red" v-else-if="atual > anterior"></i>
    <i class="fa fa-square" style="color:#3e515b" v-else></i>
  </div>
  <div v-else>
    <i class="fa fa-square" style="color:#3e515b"></i>
  </div>

</template>

<script>
  export default {
    name: "IconPosicao",
    props: ['atual', 'anterior']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Ranking/IconPosicao.vue